import 'bootstrap/dist/css/bootstrap.css';
import { PrimaryButton } from 'office-ui-fabric-react';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import bgimg from "../../../assets/1440.jpg";
import ConnectionContext from '../../../utils/ConnectionContext';
initializeIcons();
export interface ILandingPageProps {
    connectionContext: ConnectionContext;
    isAuthenticated: () => void;
}
export interface ILandingPageState {
}
const overflowcontent = mergeStyles({
    position: "absolute",
    top: "40%",
    transform: "translate(-50%)",
    color: "#fff",
    width: "90%",
    maxWidth: "100%",
    textAlign: "center",
    left: "50%"
});

const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#BDD6DD',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '500px',
    padding: '10px',
    minWidth: '200px',
    color: "#005269",
    textAlign: "justify",
    lineHeight: "1.8"
});
const submitButton = mergeStyles({ backgroundColor: '#F39000', marginRight: "5px" });
export default class TermsServices extends React.Component<ILandingPageProps, ILandingPageState>
{
    constructor(props: ILandingPageProps, state: ILandingPageState) {
        super(props);
    }
    public render(): React.ReactElement<ILandingPageProps> {
        return (
            <div className={panel}>
                <img src={bgimg} alt={"Zacco"} width={"100%"} height={"100%"} />
                <div className={overflowcontent} >
                    <h1>Welcome to the Zacco’s Agent Network</h1>
                </div>
                <div>
                    <br />
                    <p>We welcome you to the Zacco’s world-wide Agent Network where we kindly ask you to provide your best fees for any services that you are able to deliver to our clients. In this way, we hope to be able to build a strong partnership to the benefit of our clients.</p>
                    <p>This link for providing your fees will work only once. Therefore we ask you to check everything thoroughly before the final submission.</p>
                    <p>In the future, if you would like to add further jurisdictions in your portfolio of services or if you would like to change some of the fees, please send us an email at <a href="mailto:agent.network@zacco.com" target="_blank" rel="noopener noreferrer">agent.network@zacco.com</a>.</p>
                    <p>We once again welcome you to our network.</p>
                    <p><strong>Best regards<br />Zacco Agent Network Team.</strong></p>
                </div>
                <div>
                    <PrimaryButton text="Continue..." data-automation-id="test" onClick={this.props.isAuthenticated} className={submitButton}
                        iconProps={{ iconName: 'NavigateForward' }} />
                </div>
            </div>
        );
    }
}
